import { TileSetMapType, CHARACTER_DIRECTION } from "common/model";

const landscapeLayer1 = [
  [23, 17, 17, 17, 17],
  [31, 31, 31, 31, 31],
  [22, 26, 22, 26, 22],
  [31, 31, 31, 31, 31],
  [23, 23, 23, 23, 23],
];
const landscapeLayer2 = [
  [0, 14, 14, 49, 19],
  [0, 0, 0, 0, 0],
  [1, 13, 0, 13, 0],
  [0, 0, 0, 0, 0],
  [38, 0, 0, 0, 36],
];
const landscapeLayer3 = [
  [0, 39, 0, 0, 37],
  [0, 0, 0, 0, 0],
  [0, 0, 0, 0, 8],
  [0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0],
];

const landscape = [landscapeLayer1, landscapeLayer2, landscapeLayer3];

const map: TileSetMapType = {
  character: {
    direction: CHARACTER_DIRECTION.CHARACTER_DIRECTION_MINUS_X,
  },
  landscape: landscape,
};

export default map;
